<div class="content">
    <div class="row">
        <div class="col-sm-12">
            <form class="form" [formGroup]="propellerForm">
                <input type="hidden" id="id" formControlName="id" class="form-control">
                <input type="hidden" id="date" formControlName="date" class="form-control">
                <input type="hidden" id="project" formControlName="project" class="form-control">

                <div class="row">
                    <div class="col-sm-10">
                        <h5 *ngIf="propellerService.selectedEditMode == false">New Propeller</h5>
                        <h5 *ngIf="propellerService.selectedEditMode == true">Edit Propeller</h5>
                    </div>
                    <div class="col-sm-2">
                        <button type="button" class="close" aria-label="Close" title="Close" (click)="propellerService.onCloseForm()">
                                 <span aria-hidden="true"> &times;</span>
                              </button>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form form-group">
                            <label>Name*</label>
                            <input type="text" class="form-control" formControlName="name" #s_name (change)="nameCheckUnique()" />
                        </div>
                        <div *ngIf="propellerForm.controls['name'].invalid && (propellerForm.controls['name'].dirty || propellerForm.controls['name'].touched)" class="alert alert-danger">
                            <div *ngIf="propellerForm.controls['name'].errors.required">
                                Name is required.
                            </div>
                            <div *ngIf="propellerForm.controls['name'].errors.name">
                                Enter Valid Name
                            </div>
                        </div>
                        <div *ngIf="nameAlredyExist != ''" class="alert alert-danger">
                            {{nameAlredyExist}}
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <div class="form form-group">
                            <label>D*</label>
                            <input type="number" step=".001" min="0" max="100" oninput="validity.valid||(value='');" id="D" formControlName="D" class="form-control">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form form-group">
                            <label>N*</label>
                            <input type="number" step="1" min="2" max="8" id="N" formControlName="N" class="form-control">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <div class="form form-group">
                            <label>EAR*</label>
                            <input type="number" step=".01" id="EAR" formControlName="EAR" class="form-control">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form form-group">
                            <label>PD_ratio*</label>
                            <input type="number" id="PD_ratio" step=".001" min="0.4" max="1.6" formControlName="PD_ratio" class="form-control">
                        </div>
                    </div>
                </div>

                <div class="row" style="padding-top: 10px;">
                    <div class="col-sm-11">
                    </div>

                    <div class="col-sm-1" *ngIf="(propellerService.selectedEditMode == false)">
                        <button type="submit" class="btn btn-success" [disabled]="!propellerForm.valid || nameAlredyExist != ''"><i class="bx bxs-save font-size-50"(click)="onSubmit()" title="Save data"></i></button>
                        <div class="textUnderIcon">Save</div>
                    </div>

                    <div class="col-sm-1" *ngIf="(propellerService.selectedEditMode == true)">
                        <button type="submit" class="btn btn-success" [disabled]="!propellerForm.valid || nameAlredyExist != ''"><i class="bx bxs-edit-alt font-size-50"(click)="onSubmit()" title="Save edited data"></i></button>
                        <div class="textUnderIcon">Edit</div>
                    </div>

                </div>

            </form>
        </div>
    </div>
</div>